import { apiCall } from '../helpers/axios';

const ENDPOINT = 'timeslots';

const getAll = async () => {
    try {
        const response = await apiCall().get(ENDPOINT);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

const create = async (params) => {
    try {
        const response = await apiCall().post(`${ENDPOINT}/create`, params);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

const update = async (id, params) => {
    try {
        const response = await apiCall().post(`${ENDPOINT}/${id}/update`, params);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

const deleteOne = async (id) => {
    try {
        const response = await apiCall().delete(`${ENDPOINT}/${id}/delete`);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

const createType = async (params) => {
    try {
        const response = await apiCall().post(`${ENDPOINT}/types`, params);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

const updateType = async (id, params) => {
    try {
        const response = await apiCall().post(`${ENDPOINT}/types/${id}`, params);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

const deleteType = async (id) => {
    try {
        const response = await apiCall().delete(`${ENDPOINT}/types/${id}`);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

export default {
    getAll,
    create,
    update,
    deleteOne,
    createType,
    updateType,
    deleteType,
}


// WEBPACK FOOTER //
// ./src/services/timeslot-service.js